<template>
  <v-autocomplete
    v-model="inputVal"
    color="primary"
    item-color="primary"
    label="Vendor"
    :items="vendors"
    item-text="name"
    item-value="uid"
    :disabled="disabled"
  />
</template>

<script>
  export default {
    name: 'DropdownVendor',
    props: {
      value: {
        type: String,
        required: true,
        default: null,
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data: () => ({
    }),
    computed: {
      inputVal: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
        },
      },
      vendors () {
        return this.$store.state.vendors.list
      },
    },
    created: function () {
      if (this.vendors.length === 0) {
        this.refreshVendors()
      }
    },
    methods: {
      async refreshVendors () {
        this.$store.dispatch('RefreshVendors')
      },
    },
  }
</script>
